import React, { Fragment } from 'react';
import { H6, LI, P, UL, H5 } from '../../AbstractElements';
import QuickAccess from './QuickAccess';
import { Files, Folders } from '../../Constant';
import { FaClock, FaEllipsisV } from 'react-icons/fa';
import FileList from './FileList';
import { CardBody } from 'reactstrap';
const FileMainContent = ({ myfile, filelist, searchTerm }) => {
  return (
    <CardBody className='file-manager'>
      {!searchTerm && (
        <>
          <QuickAccess />
          <H5 className='mt-4'>{Folders}</H5>
          {
            <UL className='simple-list folder flex-row'>
              {myfile.map((item) => {
                return (
                  <Fragment key={item.id}>
                    {item.title && (
                      <LI className='folder-box'>
                        <div className='d-block'>
                          <i className={item.folderclass}></i>
                          <FaEllipsisV className='me-0 f-14 ellips' />
                          <div className='mt-3'>
                            <H6 className='mb-0'>{item.title}</H6>
                            <P>
                              {item.fileCount} file
                              <span className='d-flex align-item-center gap-1 pull-right'>
                                <FaClock />
                                {item.modify}
                              </span>
                            </P>
                          </div>
                        </div>
                      </LI>
                    )}
                  </Fragment>
                );
              })}
            </UL>
          }
        </>
      )}
      <H5 className='mt-4'>{Files}</H5>
      <FileList myfile={filelist} />
    </CardBody>
  );
};

export default FileMainContent;
